@if (formStateArray && formStateArray.length > 0) {
<ap-tabset [tabsetId]="'create-disclosure-shared-tabset'" [styleClass]="'gtw-tabset'" [type]="'underline'" [responsive]="true" [activeIndex]="activeIndex" (activeIndexChange)="onTabChanged($event)" [ngClass] = "{'disable-inactive-tabs':isChildEditing}">
  @for (form of formStateArray; track $index; let i = $index) {
<ap-tab [label]="form.formName" >
    @if (form) {
<dst-create-disclosure-template-viewport [tabIndex]="i"></dst-create-disclosure-template-viewport>
}
  </ap-tab>
}
</ap-tabset>
}
